import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/photos/')({
  beforeLoad: () => {
    throw redirect({ to: '/photos/me' });
  },
});
